/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Greek13Inputs */

const en__field__enum_teachingsubjects_subject_greek13 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Greek13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greek`)
};

const de__field__enum_teachingsubjects_subject_greek13 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Greek13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griechisch`)
};

/**
* | output |
* | --- |
* | "Greek" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Greek13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_greek13 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Greek13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Greek13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_greek13(inputs)
	return de__field__enum_teachingsubjects_subject_greek13(inputs)
});
export { _field__enum_teachingsubjects_subject_greek13 as "_field__enum_teachingSubjects_SUBJECT_GREEK" }